exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout_3v84rXRw {\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 50%;\n  background: rgba(0, 0, 0, .8);\n  z-index: 100000;\n  color: #fff;\n  padding: 0.533333rem;\n  overflow: scroll;\n  font-size: 0.266667rem;\n}\n\n.layout_3v84rXRw .info_1YfbHdTP .item_1NKSGvWa div:nth-child(1) {\n  font-size: 0.186667rem;\n}\n\n.layout_3v84rXRw .info_1YfbHdTP .item_1NKSGvWa div:nth-child(2) {\n  color: yellow;\n}\n\n.down_2_geK44Y {\n  top: 50%;\n  bottom: 0;\n}\n\n.end_3nrPlC9d {\n  padding-bottom: 8rem;\n}\n\n.start_1ezbs_ej {\n  padding-top: 2.666667rem;\n}", ""]);

// exports
exports.locals = {
	"layout": "layout_3v84rXRw",
	"info": "info_1YfbHdTP",
	"item": "item_1NKSGvWa",
	"down": "down_2_geK44Y",
	"end": "end_3nrPlC9d",
	"start": "start_1ezbs_ej"
};